import React, { useState, useEffect } from 'react'
import { Input, Modal, Spin, Button, message } from 'antd'
import { createMaterial, updateMaterial } from "../../../services/api/apiSku"

const MaterialCodeModal = (props) => {
    const { reload, title, isOpen, onClose, data = {} } = { ...props }
    const [loading, setLoading] = useState(false)
    const [name, setName] = useState('')
    const [minStock, setMinStock] = useState('')
    const [error, setError] = useState('')

    const isEdit = !!Object.keys(data).length

    useEffect(() => {
        if (!!Object.keys(data).length) {
            const { name: material_name, min_stock } = data

            if (!!material_name) setName(material_name)
            if (!!min_stock) setMinStock(min_stock)
        }
    }, [isOpen, data])

    const handleChangeInput = (field, e) => {
        if (field === 'name') {
            setName(e.target.value)
        }
        if (field === 'min_stock') {
            setMinStock(e.target.value)
        }
    }


    const isInteger = (value) => {
        return /^-?\d+$/.test(value)
    }

    const validate = () => {
        if (!name || !minStock) {
            message.error("Material code và min stock là bắt buộc.")
            return true
        }
        if (!isInteger(minStock)) {
            message.error("Min stock phải là số nguyên.")
            return true
        }
        return false
    }

    const closeModal = () => {
        onClose()
        setName('')
        setMinStock('')
        setError('')
    }

    const handleSave = async () => {
        try {
            setLoading(true)
            if (validate()) return

            const payload = {
                name,
                min_stock: +minStock,
                object: "BrandTag"
            }
            const { data: res = {} } = isEdit ? await updateMaterial(payload, data._id) : await createMaterial(payload)
            const { success, message: mess } = res

            if (!success) throw new Error(mess)

            if (isEdit) {
                message.success("Material code updated successfully.")
            } else {
                message.success("Material code added successfully.")
            }
            closeModal()
            reload()
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal
            width="600px"
            className="material-code-modal"
            title={title}
            visible={isOpen}
            onCancel={closeModal}
            footer={[
                <Button onClick={closeModal} style={{ backgroundColor: '#6d757d', color: '#ffffff' }}>Cancel</Button>,
                <Button type='primary' onClick={handleSave}>Save</Button>
            ]}
        >
            <Spin spinning={loading} tip='Loading...' size='large' >
                <div className="createForm mt-2 mb-3">
                    <div className="createFormItem d-flex align-items-center mb-3">
                        <label className='font-weight-bold mb-0' style={{ minWidth: '120px' }} >Material Code:</label>
                        <Input
                            placeholder='Enter material code'
                            onChange={(e) => handleChangeInput('name', e)}
                            value={name || ''}
                            allowClear
                            disabled={isEdit}
                        />
                    </div>
                    <div className="createFormItem d-flex align-items-center mb-3">
                        <label className='font-weight-bold mb-0' style={{ minWidth: '120px' }} >Min Stock:</label>
                        <Input
                            placeholder='Enter min stock'
                            onChange={(e) => handleChangeInput('min_stock', e)}
                            value={minStock || ''}
                            allowClear
                        />
                    </div>
                </div>
                {error &&
                    <span className="noti-error text-danger d-block mb-1">{error}</span>
                }
            </Spin>
        </Modal>
    )
}

export default MaterialCodeModal